import * as THREE from 'three';

// Helper to create a procedural noise texture for "Grainy/Sandpaper" look
// Creates a non-uniform noise pattern using simple random values
export const createGrainTexture = () => {
    const width = 512;
    const height = 512;
    const size = width * height;
    const data = new Uint8Array(4 * size);

    for (let i = 0; i < size; i++) {
        const stride = i * 4;
        // Non-uniformity: Mix of high frequency noise and some variance
        const noise = Math.random(); 
        const v = Math.floor(noise * 255);
        
        data[stride] = v;     // R
        data[stride + 1] = v; // G
        data[stride + 2] = v; // B
        data[stride + 3] = 255; // Alpha
    }

    const texture = new THREE.DataTexture(data, width, height, THREE.RGBAFormat);
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.repeat.set(8, 8); // Denser grain
    texture.needsUpdate = true;
    return texture;
};
